import {combineReducers} from "redux";
import {connectRouter} from "connected-react-router";
import contactsApp from "./contactsApp";
import superAdminReducer from "./superAdminReducer";
import fileReducer from "./DRM_files.reducer";
import userReducer from "./DRM_user.reducer";
import activeAppReducer from "./activeApp.reducer";
import searchReducer from "./searchReducer";
import intentListReducer from "./intentListReducer";
import kotClientReducer from "./kotClient.reducer";

const exportReducers = history => {
    return combineReducers({
        router: connectRouter(history),
        contactsApp: contactsApp,
        superAdmin: superAdminReducer,
        userStore: userReducer,
        fileStore: fileReducer,
        activeApp: activeAppReducer,
        search: searchReducer,
        intentList: intentListReducer,
        kotClient: kotClientReducer
    });
};

export default exportReducers;